import axios from "axios";

const state = () => ({
  products: [],
  text: "",
  api_url: "https://apiv2.pubcatalog.profpotok.ru",
  loading_is_complete: false,
});

const getters = {
  GET_PRODUCTS: (state) => {
    return state.products.slice(0, 100);
  },
  GET_LOADING_IS_COMPLETE: (state) => {
    return state.loading_is_complete || state.text == "";
  },
  GET_HAVE_PRODUCTS: (state) => {
    return state.products.length > 0;
  },
};

const actions = {
  SEARCH: ({ state, commit }) => {
    if (state.text == "") {
      commit("SET_PRODUCTS", []);
      commit("SET_LOADING_IS_COMPLETE", true);
      return;
    }

    let q = encodeURI(state.text);
    commit("SET_LOADING_IS_COMPLETE", false);
    axios
      .get(state.api_url + `/api/v1/search?t=${q}`)
      .then(function (response) {
        if (response.status != 200) {
          return;
        }
        commit("SET_PRODUCTS", response.data.products);
        commit("SET_LOADING_IS_COMPLETE", true);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};

const mutations = {
  SET_TEXT: (state, text) => {
    state.text = text;
  },
  SET_PRODUCTS: (state, data) => {
    state.products = data;
  },
  SET_LOADING_IS_COMPLETE: (state, data) => {
    state.loading_is_complete = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
